
import { useMemo } from 'react';
import { useLanguage } from '@/context/LanguageContext';
import { perspectiveFaces, PerspectiveFace } from '@/data/perspectiveData';
import { TranslationKey } from '@/translations/translations';

export const usePerspectiveData = () => {
    const { t, language } = useLanguage();

    const translatedFaces = useMemo(() => {
        return perspectiveFaces.map(face => {
            // Translate Face Metadata
            const translatedTitle = `${t('about.perspective.prefix')} ${t(`about.perspective.${face.id}.name` as TranslationKey)}`;
            const translatedSubtitle = t(`about.perspective.${face.id}.subtitle` as TranslationKey);

            // Translate Tiles
            const translatedTiles = face.tiles.map(tile => {
                const roleKey = `career.${tile.id}.role` as TranslationKey;
                const companyKey = `career.${tile.id}.company` as TranslationKey;
                const descKey = `career.${tile.id}.description` as TranslationKey;

                return {
                    ...tile,
                    title: t(roleKey) !== roleKey ? t(roleKey) : tile.title,
                    subtitle: t(companyKey) !== companyKey ? t(companyKey) : tile.subtitle,
                    summary: t(descKey) !== descKey ? t(descKey) : tile.summary,
                    period: t(tile.period as TranslationKey),
                    // Note: We are preserving detailedView strings for now as they are arrays 
                    // and might require deeper structure changes or specific keys
                };
            });

            return {
                ...face,
                title: translatedTitle,
                subtitle: translatedSubtitle,
                tiles: translatedTiles
            };
        });
    }, [t]);

    return translatedFaces;
};
